import { Amount, Badge, Card, Row } from '@tms/ui';

/**
 * `ADM-01`, as far as it goes today — the scaffold the console has carried since `T-0020`, moved into a
 * feature folder where a screen belongs (`STD-002 §1`). The real dashboard is phase 6, and so is
 * `AdminShell`, which is why there is no shell around this yet.
 *
 * Not lazy: it is the first thing the console renders.
 */
export function DashboardScreen(): React.JSX.Element {
  return (
    <main>
      <h1>Track My Spends — Admin</h1>
      <Card flush>
        <Row trailing={<Badge tone="credit">Active</Badge>}>Subscribers</Row>
        <Row trailing={<Amount amountMinor={3000} />}>Plan price</Row>
      </Card>
    </main>
  );
}
